import React, {FC, memo } from 'react';
import styles from './styles.scss';

const FreeForm: FC = () => {
	return (
		<div className={styles['user-agreement']}>
			<h1>AirClass隐私保护政策</h1>
			<p className={styles['info']}>上海知身为信息网络科技有限公司及其关联公司（以下称“AirClass”或“我们”）尊重并保护您的隐私。您在下载、开启、浏览、注册、登录、使用“AirClass”（含AirClass 1 on 1、AirClass kids等）网站、软件及相关产品和/或服务时，我们将按照本《隐私保护政策》（以下简称“本政策”）收集、使用、储存及对外提供您的信息。同时，我们会通过本政策向您说明，我们如何为您提供访问、更新、管理和保护您的信息的服务。本政策与您使用我们的服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益存在重大关系的条款和个人敏感信息，采用重点标注以提示您注意。</p>
            <h4>如果您不同意本政策关于基本业务功能的相关内容，可能将影响为您提供相应产品和/或服务的效果。您使用我们的产品和/或服务，即意味着同意我们按照本政策收集、使用、储存和分享您的相关信息。当本政策进行更新后，我们会及时在AirClass平台发布最新版本并通知您。
如对本政策或相关事宜有任何问题，您可以通过AirClass网站（www.air-class.com/www.airclasskids.com/www.air-class.org）首页的客服热线/在线咨询或者本政策第10条所列方式与我们联系。</h4>
			<div className={styles['content']}>
				<div className={styles['text']}>本《隐私保护政策》包含以下内容：</div>
				<p className={styles['term']}>1、我们如何收集、使用您的个人信息</p>
				<p className={styles['term']}>2、我们如何使用Cookies和同类技术</p>
				<p className={styles['term']}>3、我们如何存储您的个人信息</p>
				<p className={styles['term']}>4、我们如何共享、转让、公开披露您的个人信息</p>
				<p className={styles['term']}>5、您的权利</p>
				<p className={styles['term']}>6、我们如何保护您的个人信息</p>
				<p className={styles['term']}>7、儿童个人信息保护</p>
				<p className={styles['term']}>8、隐私保护政策的适用范围</p>
				<p className={styles['term']}>9、隐私保护政策的变更</p>
				<p className={styles['term']}>10、如何联系我们</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>1、我们如何收集、使用您的个人信息</h2>
				<p className={styles['txt']}>为了保证用户注册、课程服务、在线课程、客户服务、寄送礼包各项基本业务功能及营销活动、提升用户体验的各项扩展业务功能的正常运行，我们会收集、使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法使用和享受我们提供的某些产品和服务，或者无法达到相关产品和/或服务拟达到的效果。 我们会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
				<p className={styles['txt']}>1.1 成为“AirClass”的用户</p>
				<p className={styles['txt']}>为使用“AirClass”学习平台，<b>您需要首先成为“AirClass”的注册用户，以便我们为您提供会员服务，您需要提供注册、登录AirClass账号使用的电话号码，自行填写您或学员的姓名、昵称、微信号、头像、年龄、性别、语言、学校、年级等基本信息，并创建“AirClass”学习平台账号和密码。</b>在您主动注销账号之后，我们将根据法律的要求删除您的个人信息，或使其匿名化处理。</p>
				<p className={styles['txt']}>1.2 向您提供产品或服务</p>
				<p className={styles['txt']}>（1）基础业务功能</p>
				<p className={styles['txt']}>注册/登录：您在使用AirClass某些核心功能时，需要先完成注册和登录。注册和登录都需要您提供手机号。在您注册或登录我们的APP/网站之后，我们会根据您预留的联系信息与您联系，便于向您提供符合您需求的产品和服务。同时我们也支持更方便快捷的共享登录方式，即如果设备上安装了AirClass旗下相关产品，并已在该产品中完成注册登录，我们将使用对应登录手机号为您直接完成登录并予以告知。完成共享登录需要读取您的设备应用列表。</p>
				<p className={styles['txt']}>查看和编辑个人资料：您可以选择是否在AirClass上完善个人信息，可自行上传和编辑个人头像、姓名、年级、学校、地址信息。上传头像功能需要获取您的摄像头或相册权限，您在设置学校时可以选择自动获取您的地理位置信息帮助筛选学校，也可以手动输入进行筛选。</p>
				<p className={styles['txt']}>购买课程：您在AirClass购买课程产品时，您需要提供联系人姓名、地址信息、联系方式。邮寄：当您在AirClass上使用邮寄（例如邮寄课程随材）服务时，您需要提供收件人的姓名、手机号码、通信地址，以便于您的订单能够安全准确送达。</p>
				<p className={styles['txt']}>支付：您在AirClass上支付时，您可以选择AirClass及与AirClass合作的第三方支付机构（如
微信支付、支付宝、招行一网通等支付通道）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的AirClass订单信息及对账信息与这些支付机构共享以确认您的支付指令并完成支付。</p>
				<p className={styles['txt']}>余额充值和提现：您可通过微信支付、支付宝、招行一网通等方式充值AirClass余额，账号中的余额如需提现，您需要向客服提供您的AirClass账号、银行卡信息（账号、持卡人姓名、开户行名称）。</p>
				<p className={styles['txt']}>上课前提醒：在使用上课提醒服务时，需要将相关课程信息写入您的日历。</p>
				<p className={styles['txt']}>上课：您可以观看已经购买的课程的直播和回放视频，直播过程中可参与授课老师的互动教
学，例如跟读、语音/视频上麦、在课堂发言。参与这些互动需要获取您的麦克风、摄像头权限，讨论区将展示您自行填写的昵称以及您发布的留言内容。</p>
				<p className={styles['txt']}>习题：授课老师布置题目后，您可以直接在AirClass手机APP上作答，并获得老师批改。
作答形式支持学生选择答案、输入文字和拍照上传图片。这个过程可能需要您的拍摄照片的权限，上传照片或保存习题答案等可能需要读取、修改或删除您的SD卡中的内容的权限课后练习：授课老师布置内容后，您可以直接在AirClassAPP上完成学习，并获得老师点评。完成学习任务可能需要录制视频，录制过程需获取您的麦克风、摄像头、相机、录屏权限</p>
				<p className={styles['txt']}>考试/课堂测验：课程学习过程中会进行考试或课堂测验，作答过程中课程需要获取您的拍摄照片权限。</p>
				<p className={styles['txt']}>学习能力测试：您在购买课程之前，可以选择是否参加某一科目的学习能力测试，作答完成
后将由系统判定出对应得分。AirClass将保存该得分，并依据该得分为您推荐合适的课程。</p>
				<p className={styles['txt']}>（2）附加业务功能：</p>
				<p className={styles['txt']}>下载课程回放视频/查看和管理离线课程：为了方便随时回看课程视频，您可以免费下载直播已结束的课程视频到客户端本地，同时也可以删除下载到本地的视频。这项服务需要获取读取、修改或删除您的SD卡中的内容的权限。</p>
				<p className={styles['txt']}>发布课程评价：您报名的课程直播结束后，可以对该节课程做出总体评价，也可以发表评论留言。当您在AirClass上主动对课程进行评价时，我们将收集您发布的信息，并展示您的头像、姓名、年级、学校和发布内容。</p>
				<p className={styles['txt']}>联系客服或老师：与客服联系或老师交流时，您可以授权我们APP直接拨打电话的权限。积分商城：您可以使用积分在积分商城兑换学习用具和AirClass周边产品，邮寄商品需要您提供收件人的姓名、手机号码、通信地址，以便于您兑换的商品能够安全准确送达。</p>
				<p className={styles['txt']}>（3）用户体验优化：</p>
				<p className={styles['txt']}>AirClass将基于您对“AirClass”使用数据，结合个人常用设备信息进行统计，来诊断系统问题，优化产品体验。</p>
				<p className={styles['txt']}>我们会采取脱敏、去标识化等方式对您的信息进行综合统计、分析加工，以便为您提供更加
准确、个性、流畅及便捷的服务，或帮助我们评估、改善、设计服务及活动；为了提升用户服务体验，为用户推荐更为优质或适合的服务，我们可能会根据用户信息形成群体特征标签，用于向用户提供其可能感兴趣的课程内容，营销活动，如您不希望接收此类信息，您可以在APP的设置中关闭个性推荐</p>
				<p className={styles['txt']}>我们会使用工具（含第三方工具SDK）统计您在使用AirClass科技产品过程中产生的数据
信息，其中包含应用启动数，页面访问数，重点按钮点击数，设置项的配置属性。随着AirClass科技产品的后续版本升级，我们统计的范围会有所改变，您下载/安装/使用AirClass科技后续版本产品的行为将被视为您对届时相关改变的同意。</p>
				<p className={styles['txt']}>（4）开展营销活动</p>
				<p className={styles['txt']}>当您选择参加我们举办的有关营销活动时，根据活动需要可能使用到您提供个人信息与第三方支付服务账号。这些信息可能包括个人敏感信息（个人电话号码、支付宝账号），是您收到转账或者礼品所必要的。如果您拒绝提供这些信息，我们将可能无法向您转账或发放礼品。</p>
				<p className={styles['txt']}>（5）客服与售后</p>
				<p className={styles['txt']}>我们的客服和售后功能会使用你的账号信息以为您提供咨询服务。当您与我们联系时，我们可能会保存您的通信或通话记录和内容或您留下的联系方式，以便帮助您解决问题，或记录相关问题的处理方案及结果。我们的客服会使用您的账号信息与您核验您的身份。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。</p>
				<p className={styles['txt']}>（6）部分服务由合作伙伴共同为您提供</p>
				<p className={styles['txt']}>为保障AirClass客户端APP的稳定运行或实现相关功能，我们会接入一些由第三方提供的
软件开发包（SDK）实现服务之目的。我们接入的部分第三方SDK可能涉及收集您的个人信息，用于向您提供更好服务。我们会评估所有第三方收集信息的合法性、正当性、必要性，对第三方SDK或其他类似的应用程序进行严格的安全检测，要求第三方对您的信息采取严
格的数据保护措施，并且严格遵守相关法律法规与监管要求，切实保障您的合法权益。为了向您提供更多服务、保证服务稳定性和质量或者升级相关功能时，我们可能需要调整我们接入的第三方SDK。</p>
				<p className={styles['txt']}>1.3收集及使用信息时为您提供安全保护保障</p>
				<p className={styles['txt']}>（1）您的网络身份标识信息帮助您维护软件正常使用及使用安全。</p>
				<p className={styles['txt']}>（2）我们将通过弹出窗口询问您是否可以获取相应权限，只有您选择同意后，我们才会为您开启相应权限并接受您的个人信息</p>
				<p className={styles['txt']}>（3）您可以开放设备麦克风权限来进行语音输入（语音消息、语音搜索），在此过程中我们使用您的语音内容，对此项AirClass使用数据进行必要的处理以满足您的软件使用需求。</p>
				<p className={styles['txt']}>（4）我们会根据您在软件安装及使用中授予的具体权限，接收并记录您的个人常用设备信
息：操作系统版本、唯一设备标识符、设备所在位置相关信息：IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙等传感器信息</p>
				<p className={styles['txt']}>（5）个人信息匿名化处理：在收集到您的个人信息后，我们将通过技术手段及时对数据进
行匿名化处理。我们会将匿名化后的数据与可用于回复识别个人的信息分开存储，并保证在后续的个人信息处理中不重新识别个人。在不泄露您个人信息的前提下，AirClass科技有权对匿名化处理后的用户数据库进行挖掘、分析和利用（包括商业性使用）。</p>
				<p className={styles['txt']}>（6）若我们对于您的个人信息用于除政策列明之外的目的、范围或与使用于数据收集不一
致的传输方式时，我们将会通知您并取得您的同意。</p>
				<p className={styles['txt']}>1.4征得授权同意的例外</p>
				<p className={styles['txt']}>（1）与国家安全、国防安全直接相关的；</p>
				<p className={styles['txt']}>（2）与公共安全、公共卫生、重大公共利益直接相关；</p>
				<p className={styles['txt']}>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
				<p className={styles['txt']}>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
				<p className={styles['txt']}>（5）所收集的个人信息是您自行向社会公众公开的；</p>
				<p className={styles['txt']}>（6）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道；</p>
				<p className={styles['txt']}>（7）根据您的要求签订和履行合同所必须的；</p>
				<p className={styles['txt']}>（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现或处置产品或服务的故障；</p>
				<p className={styles['txt']}>（9）为新闻单位或学术研究机构基于新闻报道、公共利益开展统计或学术研究所必要等，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理，且数据接收方无法复原并重新识别个人信息的；</p>
				<p className={styles['txt']}>（10）法律法规规定的其他情形。</p>
				<p className={styles['txt']}>2、我们如何使用Cookies和同类技术</p>
				<p className={styles['txt']}>我们或我们的第三方合作伙伴，可能通过cookies收集和使用您的信息，并将该等信息储存为日志信息。</p>
				<p className={styles['txt']}>我们使用自己的cookies，目的是为您提供更个性化的用户体验和产品和/或服务，并用于以下用途：</p>
				<p className={styles['txt']}>（1）记住您的身份。cookies有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息</p>
				<p className={styles['txt']}>（2）分析您使用我们产品和/或服务的情况。我们可利用cookies来了解您使用我们的产品和/或服务进行什么活动，或哪些网页或产品和/或服务最受您的欢迎；</p>
				<p className={styles['txt']}>我们为上述目的使用cookie或webbeacon的同时，可能将通过cookies收集的非个人身份信息，用于分析用户如何使用我们的产品和/或服务。</p>
				<p className={styles['txt']}>您可以通过浏览器设置拒绝或管理cookies。但请注意，如果停用cookies或webbeacon，您
有可能无法享受最佳的服务体验，某些产品和/或服务也可能无法正常使用。为了确认您的使用形态与网站的使用状况，我们的网站会记录您设备的IP地址与浏览器的类型，用户的浏览行为和操作行为等，以协助我们改善AirClass的设计与编排格式。</p>
				<p className={styles['txt']}>3、我们如何存储您的个人信息</p>
				<p className={styles['txt']}>您的个人信息将在实现业务功能必要目的所需的最短时间内存储，超过该等保存期限，将对个人信息进行删除或者匿名化处理。我们在中华人民共和国境内运营中收集和产生的个人信息，原则上存储在中国境内，不会向中国以外跨境转移。以下情形除外：</p>
				<p className={styles['txt']}>（1）法律法规有明确规定；</p>
				<p className={styles['txt']}>（2）获得您的明确授权。</p>
				<p className={styles['txt']}>针对以上情形，我们也会确保依据法律法规和本《隐私保护政策》对您的个人信息提供安全
保护。</p>
				<p className={styles['txt']}>4、我们如何共享、转让、公开披露您的个人信息</p>
				<p className={styles['txt']}>4.1共享</p>
				<p className={styles['txt']}>我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：</p>
				<p className={styles['txt']}>（1）我们的关联公司</p>
				<p className={styles['txt']}>我们将基于AirClass统一管理的目的及必要合理原则向我们的关联公司共享您的课程等个人信息，以实现基本业务功能并帮助我们设计新的商业模式，评估和改进我们的服务，提升用户体验等。为此目的，您的个人信息可能会被传输至我们的关联公司。我们的关联公司将依照可适用的数据保护法等适用法律安全地处理您的个人信息。</p>
				<p className={styles['txt']}>（2）合作伙伴</p>
				<p className={styles['txt']}>在法律法规允许的范围内，为维护AirClass、AirClass的合作伙伴、您或其他AirClass用户
或社会公众利益、财产或安全免遭损害，我们仅为实现本《隐私保护政策》中声明的目的与授权合同伙伴共同提供某些服务。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将审慎评估合作方使用共享信息的
目的，对合作方的安全保障能力进行综合评估，我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全，我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的授权合作伙伴包括以下类型：</p>
				<p className={styles['txt']}>(a)商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心功能；</p>
				<p className={styles['txt']}>(b)第三方商家。我们必须将您为实现操作目的之必要信息与第三方商家共享，并促使其可以完成后续服务；</p>
				<p className={styles['txt']}>（3）我们的服务商</p>
				<p className={styles['txt']}>我们可委任第三方服务提供者代表我们管理及/或操作若干功能或服务，而妥善执行该等功能或服务可能需要移转您所提交的信息。例如我们将基于配送需求向物流公司共享您的收货人信息、地址信息及手机号，以完成物品配送；我们还可能基于为您提供服务向服务商基于必要合理原则提供您的个人信息，以完成或提升为您提供的服务。</p>
				<p className={styles['txt']}>（4）我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。对于共享您个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本《隐私保护政策》以及其他任何相关的保密和安全措施来处理个人信息。</p>
				<p className={styles['txt']}>4.2 转让</p>
				<p className={styles['txt']}>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
				<p className={styles['txt']}>（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
				<p className={styles['txt']}>（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此《隐私保护政策》的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
				<p className={styles['txt']}>4.3 公开披露</p>
				<p className={styles['txt']}>我们仅会在以下情况下，公开披露您的个人信息：</p>
				<p className={styles['txt']}>（1）获得您明确授权同意后；</p>
				<p className={styles['txt']}>（2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
				<p className={styles['txt']}>5、您的权利</p>
				<p className={styles['txt']}>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
				<p className={styles['txt']}>（1）访问您的个人信息</p>
				<p className={styles['txt']}>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以
通过登录自己的账户直接查看或修改账户设置和信息，也可以通过我们网站（www.air-class.com/www.airclasskids.com/www.air-class.org）或客户端中的客服与我们联系进行查看和修改</p>
				<p className={styles['txt']}>（2）更正您的个人信息</p>
				<p className={styles['txt']}>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过“访问您的个人信息”中罗列的方式提出更正申请。我们将在15天内回复您的更正请求。</p>
				<p className={styles['txt']}>（3）删除您的个人信息</p>
				<p className={styles['txt']}>在以下情形中，您可以向我们提出删除个人信息的请求</p>
				<p className={styles['txt']}>-如果您不再使用我们的产品或服务，或您注销了账号；</p>
				<p className={styles['txt']}>-如果我们收集、使用您的个人信息，却未征得您的同意；</p>
				<p className={styles['txt']}>-如果我们处理个人信息的行为违反了与您的约定；</p>
				<p className={styles['txt']}>-如果我们终止了产品或服务。</p>
				<p className={styles['txt']}>-如果我们处理个人信息的行为违反法律法规；</p>
				<p className={styles['txt']}>您可以通过我们网站（www.air-class.com/www.airclasskids.com/www.air-class.org）首页的客
服热线提出您的删除请求。若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权</p>
				<p className={styles['txt']}>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
				<p className={styles['txt']}>（4）撤回或改变您授权同意的范围</p>
				<p className={styles['txt']}>每个基本业务功能需要一些基本的个人信息才能得以完成。对于为了实现扩展业务功能之目的而收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意，您可以通过设备系统权限设置对于您的授权进行管理。</p>
				<p className={styles['txt']}>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
				<p className={styles['txt']}>（5）个人信息主体注销账户</p>
				<p className={styles['txt']}>您可通过我们网站（www.air-class.com/www.airclasskids.com/www.air-class.org）首页的客服
热线或者登录后”个人中心-个人设置-注销账号“，客户端”我的-设置-注销“中申请注销您的账户，在您提供相关信息后，我们核实不影响您在我们网站行使其他权益后，为您办理相应手续。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>
				<p className={styles['txt']}>（6）响应您的请求</p>
				<p className={styles['txt']}>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您
验证自己的身份，然后再处理您的请求。我们将在十五天内作出答复。如您不满意，您可以通过AirClass网站（www.air-class.com/www.airclasskids.com/www.air-class.org）首页的客服热线或者在线咨询进行投诉。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
				<p className={styles['txt']}>5.2我们可能无法响应您的请求的情形</p>
				<p className={styles['txt']}>尽管有上述约定，但按照相关法律法规及国家标准，在以下情形中，我们可能无法响应您的请求：</p>
				<p className={styles['txt']}>（1）与个人信息控制者履行法律法规规定的义务相关的；</p>
				<p className={styles['txt']}>（2）与国家安全、国防安全直接相关的；</p>
				<p className={styles['txt']}>（3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
				<p className={styles['txt']}>（4）与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
				<p className={styles['txt']}>（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
				<p className={styles['txt']}>（6）为了维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
				<p className={styles['txt']}>（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
				<p className={styles['txt']}>（8）涉及商业秘密的。</p>
				<p className={styles['txt']}>6、我们如何保护您的个人信息</p>
				<p className={styles['txt']}>6.1我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>
				<p className={styles['txt']}>我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
				<p className={styles['txt']}>6.2信息传输SSL（SecureSocketLayer）协议加密保护。</p>
				<p className={styles['txt']}>当您从设备或浏览器向我们的服务器发送或收取信息时，我们确保使用安全套接层（SSL）和其他算法对其进行加密。</p>
				<p className={styles['txt']}>6.3我们会采取一切合理可行的措施，确保未收集无关的个人信息。</p>
				<p className={styles['txt']}>我们只会在达成本政策所述目的所需的三年内保留您的个人信息，除非需要延长保留期或受到法律的允许。超出期限后，我们将删除或去标识化处理您的个人信息。</p>
				<p className={styles['txt']}>6.4您的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。</p>
				<p className={styles['txt']}>我们依据重要性和敏感性对您的数据进行分类，并且保证您的个人信息具有最高的安全等级。
我们保证通过访问这些信息来帮助向您提供产品和服务的员工和第三方服务供应商具有严格的合同保密义务，如果未能履行这些义务，其将会受到纪律处分或被终止合作。同样，我们对以云为基础的数据存储设有专门的访问控制措施。总而言之，我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。</p>
				<p className={styles['txt']}>尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素
而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。我们将对于个人数据的泄露，及时通知相关的监管机构，并在一些特别的环境下，通知数据主体相关的数据泄露事件，以满足适用的相关法律，包括您所在地的数据保护法规。</p>
				<p className={styles['txt']}>我们不对有可能进入第三方网站的隐私保护政策的合法性负责，您应检查第三方网站的隐私保护政策并确定是否接受。</p>
				<p className={styles['txt']}>6.5信息安全事件</p>
				<p className={styles['txt']}>如果不幸发生个人信息安全事件，我们会按照法律法规的要求并最迟不迟于30个自然日内向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范或降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
				<p className={styles['txt']}>7、儿童个人信息保护</p>
				<p className={styles['txt']}>我们了解，我们所收集、处理的学员个人信息可能来自14周岁以下未成年人（“儿童”），
我们非常重视对儿童个人信息的保护。对此，我们严格按照《中华人民共和国网络安全法》、
《儿童个人信息网络保护规定》等国内个人信息保护的相关规定，落实保护责任，作出以
下承诺：</p>
				<p className={styles['txt']}>（1）未经监护人同意，儿童不得创建自己的AirClass用户账户；</p>
				<p className={styles['txt']}>（2）在收集儿童个人信息前，我们将提醒儿童及其监护人阅读本《隐私保护政策》，向其
告知我们收集、处理儿童个人信息的场景，以及我们所采取的信息安全保护措施；</p>
				<p className={styles['txt']}>（3）我们将仅在获取儿童监护人授权同意的前提下收集、处理儿童个人信息，且严格按照法律规定在监护人同意或者在保护儿童所必要的情况下处理这部分个人信息；</p>
				<p className={styles['txt']}>（4）我们已为儿童及其监护人提供拒绝上述收集、处理行为的方式。儿童及其监护人可以通过本《隐私保护政策》第10条所附联系方式与我们取得联系，表达具体的拒绝意向，我们会在做好身份识别的基础上进行处理；</p>
				<p className={styles['txt']}>（5）一般情况下，我们不会收集与实现本隐私保护政策所描述相应功能场景无关的个人信息；如因业务需要，确需超出约定的目的、范围收集、处理的，我们会具体告知儿童监护人并征得其同意；</p>
				<p className={styles['txt']}>（6）我们会严格设定不同功能下的信息访问权限，控制儿童个人信息知悉范围；</p>
				<p className={styles['txt']}>（7）儿童及其监护人同样享有本《隐私保护政策》第5条所描述的个人信息主体的权利；</p>
				<p className={styles['txt']}>（8）按照国内个人信息相关法律法规及标准要求、本《隐私保护政策》展现的存储要求及保护措施，保障儿童个人信息安全。</p>
				<p className={styles['txt']}>（9）为更好的保护未成年人信息保护，我们会指定专人负责儿童个人信息保护事宜，如有相关疑问可发送邮件至第10条所附联系方式与我们联系。</p>
				<p className={styles['txt']}>8、隐私保护政策的适用范围</p>
				<p className={styles['txt']}>除某些特定产品和服务外，我们所有的产品和/或服务均适用本《隐私保护政策》。这些特
定产品和服务将适用特定的隐私保护政策。针对某些特定产品和服务的特定隐私保护政策，
将更具体地说明我们在该等产品和服务中如何使用您的信息。该特定产品和/或服务的隐私
保护政策构成本《隐私保护政策》的一部分。如相关特定服务的隐私保护政策与本《隐私保
护政策》有不一致之处，适用该特定产品和/或服务的隐私保护政策。</p>
				<p className={styles['txt']}>请您注意，本《隐私保护政策》仅适用于我们所收集、保存、使用、共享、披露信息。除非
本《隐私保护政策》另有明确所指，本《隐私保护政策》不适用于以下情况</p>
				<p className={styles['txt']}>a）通过我们的产品和/或服务而接入的第三方服务（包括任何第三方网站）收集的信息；</p>
				<p className={styles['txt']}>b）通过在我们产品和/或服务中进行广告服务的其他公司或机构所收集的信息。</p>
				<p className={styles['txt']}>请您知悉：如果您浏览第三方网站或使用第三方的产品和／或服务时向该第三方提供您的个
人信息，您的信息应当适用该第三方的隐私声明或类似政策，我们对任何第三方不当使用或
披露由您提供的信息不承担任何法律责任，无论您登录或浏览上述网站、软件，或使用其产
品和/或服务是否基于AirClass的链接或引导。</p>
				<p className={styles['txt']}>9、隐私保护政策的变更</p>
				<p className={styles['txt']}>我们的隐私保护政策可能变更</p>
				<p className={styles['txt']}>我们保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少
（即“重大变更”），我们会通过不同渠道向您发送变更通知，包括但不限于网站公示、电子
邮件、私信通知等方式。</p>
				<p className={styles['txt']}>若您不同意修改后的隐私保护政策，您有权并应立即停止使用AirClass的服务。如果您继续
使用我们的服务，则视为您接受我们对本政策相关条款所做的修改。</p>
				<p className={styles['txt']}>AirClass的所有服务均适用本政策。但某些服务有其特定的隐私保护政策，该等特定的隐私
保护政策更具体地说明AirClass在该服务中如何处理您的信息。如本政策与特定服务的隐私
保护政策有不一致之处，请以该特定隐私保护政策为准。</p>
				<p className={styles['txt']}>本政策所指的重大变更包括但不限于：</p>
				<p className={styles['txt']}>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
				<p className={styles['txt']}>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
				<p className={styles['txt']}>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
				<p className={styles['txt']}>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
				<p className={styles['txt']}>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</p>
				<p className={styles['txt']}>（6）个人信息安全影响评估报告表明存在高风险时；</p>
				<p className={styles['txt']}>（7）我们还会将本政策的旧版本存档，供您查阅。</p>
				<p className={styles['txt']}>在“AirClass”学习平台停止运营时，我们会及时停止继续收集个人信息，可能以注意送达或
网站公告的形式通知您停止运营的情况，并对您的个人信息进行删除或匿名化处理。</p>
			</div>
			<h3>上海知身为信息网络科技有限公司及其关联公司</h3>
		</div>
	);
}
export default memo(FreeForm);
